// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"430":"f7145893","541":"f12e13c4","748":"5d756363"}[chunkId] + ".chunk.css";
};